module.exports = __webpack_public_path__ + "static/media/NineLogo.98c1848a.png";